<template>
  <div>
    <div
      v-if="filterListTitle!=='' || withOrderBelow===true"
      class="articleFilters__between">
      <h2
        v-if="filterListTitle"
        class="articleFilters__title">
        {{ filterListTitle }}
      </h2>
      <div
        v-if="withOrder && withOrderBelow===true"
        class="articleFilters__select select__select select--light">
        <label class="select__label">{{ sortTitle }}
          <select
            v-model="orderBy"
            name="articlefilter"
            aria-label="sortTitle"
            @change="orderChange()"
          >
            <!-- <option value="recommendation">recommendation</option> -->
            <option value="date">{{ sortItemDate }}</option>
            <!-- <option value="author">author</option> -->
            <option value="title">{{ sortItemTitle }}</option>
          </select>
        </label>
      </div>
    </div>

    <div
      v-if="withFilters || (withOrder && withOrderBelow!==true)"
      class="articleFilters articleFilters--padding">
      <h2
        v-if="filterTitle"
        class="articleFilters__title"
      >
        {{ filterTitle }}
      </h2>
      <ul
        v-if="withFilters"
        class="articleFilters__items">
        <li class="articleFilters__item">
          <a
            class="button button--whiteWithBorder"
            :class="{ active: !filterSlug }"
            @click.prevent="filterChange()"
          >
            {{ allCatsText }}
          </a>
        </li>
        <li
          v-for="(aFilter, aFilterIndex) in articleFilters.categories"
          :key="aFilterIndex"
          class="articleFilters__item"
        >
          <a
            class="button button--whiteWithBorder"
            :class="{ active: aFilter.slug === filterSlug }"
            @click.prevent="filterChange(aFilter.slug)"
          >
            {{ aFilter.name }}
          </a>
        </li>
      </ul>

      <div
        v-if="withOrder && withOrderBelow!==true"
        class="articleFilters__select select__select select--light">
        <label class="select__label">{{ sortTitle }}
          <select
            v-model="orderBy"
            name="articlefilter"
            aria-label="sortTitle"
            @change="orderChange()"
          >
            <!-- <option value="recommendation">recommendation</option> -->
            <option value="date">{{ sortItemDate }}</option>
            <!-- <option value="author">author</option> -->
            <option value="title">{{ sortItemTitle }}</option>
          </select>
        </label>
      </div>
    </div>


    <div v-if="loading" class="articleMasonry__loader">
      <div class="loader">
        Loading...
      </div>
    </div>
    <!-- <div v-else> -->
    <div v-else class="articleGrid">
      <!-- <masonry
        :cols="{default: 3, 1024: 2, 600: 1}"customType
        :gutter="46"
      > -->
      <div class="articleGrid__items">
        <div
          v-for="(item, index) in posts"
          :key="index"
          :class="['articleGrid__item', {'articleGrid__item--wide': item.customType === 'video'}]"
        >
          <div v-if="!item.customType && item.type === 'video'" class="postThumb">
            <div class="postThumb__iframe">
              <iframe
                :src="item.video_embed"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                loading="lazy"
              ></iframe>
              <div class="postThumb__category">
                <div v-if="item.printAllCategories">
                  <div
                      v-for="cat in item.categories"
                      :key="cat.slug"
                      class="postThumb__category__item">
                    <a :href="'category/' + cat.slug" class="postThumb__link" v-html="cat.name">
                    </a>
                  </div>
                </div>
                <div v-else>
                  <div v-if="item.categories && item.categories.length > 0" class="postThumb__category__item">
                    <a :href="'category/' + item.categories[0].slug" class="postThumb__link" v-html="item.categories[0].name"></a>
                  </div>
                </div>
              </div>
              <div v-if="item.imgcopyright" class="postThumb__copy">
                <div
                    class="postThumb__copyDetails"
                    v-html="item.imgcopyright"></div>
              </div>
              <div v-if="item.tagslug && item.tagslug.length !== 0" class="postThumb__tag">
                <div
                    class="postThumb__tag__item"
                    :class="`postThumb__tag__item--${item.tagslug}`"
                    :title="item.tag"
                >{{ item.tag }}</div>
              </div>
            </div>
             <div class="postThumb__content">
              <a :href="item.permalink" class="postThumb__link">
                <h3 class="heading__h3 postThumb__title">
                  <span class="postThumb__titleUnderline" v-html="item.title"></span>
                </h3>

                <!-- <div class="link link--blank"></div> -->
              </a>
              <span class="postThumb__description" v-html="item.description"></span>
              <div class="postThumb__authorsDate">
                <div
                    v-if="item.authorsDetailed.length >= 1 && item.authorsDetailed.length < 3"
                    class="authorsDetailed__container">
                  <div class="authorsDetailed__item" v-for="author in item.authorsDetailed" :key="author.name">
                    <div class="authorsDetailed__item__thumb">
                      <a :href="author.link"
                          v-html="author.thumb"></a>
                    </div>
                    <div>
                      <div class="authorsDetailed__item__small">
                        {{ authorsDetailedLabel }}
                      </div>
                      <div class="authorsDetailed__item__name">
                        <a :href="author.link">
                          {{author.name}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    v-if="item.authorsDetailed && item.authorsDetailed.length >= 3"
                    class="authorsDetailed__container">
                  <div class="authorsDetailed__item">
                    <div>
                      <div class="authorsDetailed__item__small">
                        {{ authorsDetailedLabel }}
                      </div>
                      <div class="authorsDetailed__item__name">
                        <span v-for="(author, index) in item.authorsDetailed" :key="author.name">
                          <a :href="author.link">{{
                              author.name
                            }}{{
                              item.authorsDetailed.length > 1 && index < item.authorsDetailed.length - 1 ? ', ' : ''
                            }} </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="postThumb__date">
                  {{ item.dateString }}
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="!item.customType" class="postThumb">
            <a
              :href="item.permalink"
              class="postThumb__image"
              :style="'background-image: url(' + item.thumbnail + ')'"
            >
              <div class="postThumb__category">
                <div v-if="item.printAllCategories">
                  <div
                    v-for="cat in item.categories"
                    :key="cat.slug"
                    class="postThumb__category__item">
                    <a :href="'category/' + cat.slug" class="postThumb__link" v-html="cat.name">
                    </a>
                  </div>
                </div>
                <div v-else>
                  <div v-if="item.categories && item.categories.length > 0" class="postThumb__category__item">
                    <a :href="'category/' + item.categories[0].slug" class="postThumb__link" v-html="item.categories[0].name"></a>
                  </div>
                </div>
              </div>
              <div v-if="item.imgcopyright" class="postThumb__copy">
                <div
                  class="postThumb__copyDetails"
                  v-html="item.imgcopyright"></div>
              </div>
              <div v-if="item.tagslug && item.tagslug.length !== 0" class="postThumb__tag">
                <div
                  class="postThumb__tag__item"
                  :class="`postThumb__tag__item--${item.tagslug}`"
                  :title="item.tag"
                >{{ item.tag }}</div>
              </div>
              <!--<div
                v-if="item.type == 'video'"
                class="postThumb__type button button--static button--social button--play-circle">
              </div>
              <div
                v-if="item.type == 'podcast'"
                class="postThumb__type button button--static button--social button--microphone">
              </div>-->
            </a>
            <div class="postThumb__content">
              <a :href="item.permalink" class="postThumb__link">
                <h3 class="heading__h3 postThumb__title">
                  <span class="postThumb__titleUnderline" v-html="item.title"></span>

                </h3>

                <!-- <div class="link link--blank"></div> -->
              </a>
              <span class="postThumb__description" v-html="item.description"></span>
              <div class="postThumb__authorsDate">
                <div
                    v-if="item.authorsDetailed.length >= 1 && item.authorsDetailed.length < 3"
                    class="authorsDetailed__container">
                  <div class="authorsDetailed__item" v-for="author in item.authorsDetailed" :key="author.name">
                    <div class="authorsDetailed__item__thumb">
                      <a :href="author.link"
                          v-html="author.thumb"></a>
                    </div>
                    <div>
                      <div class="authorsDetailed__item__small">
                        {{ authorsDetailedLabel }}
                      </div>
                      <div class="authorsDetailed__item__name">
                        <a :href="author.link">
                          {{author.name}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    v-if="item.authorsDetailed && item.authorsDetailed.length >= 3"
                    class="authorsDetailed__container">
                  <div class="authorsDetailed__item">
                    <div>
                      <div class="authorsDetailed__item__small">
                        {{ authorsDetailedLabel }}
                      </div>
                      <div class="authorsDetailed__item__name">
                        <span v-for="(author, index) in item.authorsDetailed" :key="author.name">
                          <a :href="author.link">{{
                              author.name
                            }}{{
                              item.authorsDetailed.length > 1 && index < item.authorsDetailed.length - 1 ? ', ' : ''
                            }} </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="postThumb__date">
                  {{ item.dateString }}
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="item.customType === 'text' && !filterSlug">
            <div class="postThumb postThumb--blue">
              <div v-if="item.imageUrl" class="postThumb__image" :style="'background-image: url(' + item.imageUrl + ')'"></div>
              <div class="postThumb__content">
                <span class="postThumb__kicker" v-if="item.kicker" v-text="item.kicker"></span>
                <h3 class="heading__h3 postThumb__title" v-html="item.title"></h3>
                <span class="postThumb__description" v-html="item.text"></span>
                <div class="postThumb__authorsDate">
                  <a v-if="item.linkUrl" :href="item.linkUrl" class="button button--link">
                    {{ item.linkTitle }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="item.customType === 'programm' && !filterSlug">
            <div class="postThumb postThumb--programm">
              <div v-if="item.imageUrl" class="postThumb__image" :style="'background-image: url(' + item.imageUrl + ')'"></div>
              <h3 class="heading__h3 postThumb__title" v-html="item.title"></h3>
              <a v-if="item.linkUrl" :href="item.linkUrl" class="button button--link" target="_blank" rel="noopener noreferrer">
                {{ item.linkTitle }}
              </a>
            </div>
          </div>
          <div v-else-if="item.customType === 'video' && !filterSlug">
            <div class="postThumb postThumb--iframeWrapper">
              <div class="postThumb__iframe">
                <iframe
                  :src="item.src"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  loading="lazy"
                ></iframe>
              </div>
              <div v-if="item.title" class="postThumb__content">
                <a v-if="item.linkUrl" :href="item.linkUrl" class="postThumb__link">
                  <h3 class="heading__h3 postThumb__title">
                    <span class="postThumb__titleUnderline">{{ item.title }}</span>
                  </h3>
                </a>
                <h3 v-else class="heading__h3 postThumb__title">
                  <span class="postThumb__titleUnderline">{{ item.title }}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </masonry> -->
    </div>

    <div v-if="loadingMore" class="articleMasonry__loader">
      <div class="loader">
        Loading...
      </div>
    </div>

    <div
      v-if="mehrVisible"
      class="articleMasonry__more"
    >
      <a
        class="button button--reload"
        :class="{ 'link--disabled': loading || loadingMore }"
        @click.prevent="loadMore()">
        {{ moreText }}
      </a>
    </div>
  </div>
</template>

<script>


export default {
  props:
      {
        homeUrl: {
          type: String,
          default: '',
        },
        apiUrl: {
          type: String,
          default: 'test',
        },
        articles: {
          type: Array,
          default: null,
        },
        count: {
          type: Number,
          default: 0,
        },
        postsCount: {
          type: Number,
          default: 6,
        },
        postType: {
          type: String,
          default: 'post',
        },
        foo: {
          type: String,
          default: '',
        },
        loaderOn: {
          type: Boolean,
          default: false,
        },
        // permalink of a post shown elsewhere on the page (e.g. header stage), kept out of the loaded list
        excludePermalink: {
          type: String,
          default: '',
        },
        homepage: {
          type: Boolean,
          default: false,
        },
        moreText: {
          type: String,
          default: 'load more',
        },
        allCatsText: {
          type: String,
          default: 'all',
        },
        staticItems: {
          type: Array,
          default: null,
        },
        articleFilters: {
          type: Object,
          default: null,
        },
        archiveFilters: {
          type: Object,
          default: null,
        },
        withFilters: {
          type: Boolean,
          default: false,
        },
        withOrder: {
          type: Boolean,
          default: false,
        },
        withOrderBelow: {
          type: Boolean,
          default: false,
        },
        authorsDetailedBlock: {
          type: Boolean,
          default: false,
        },
        authorsDetailedLabel: {
          type: String,
          default: '',
        },
        filterTitle: {
          type: String,
          default: '',
        },
        filterListTitle: {
          type: String,
          default: '',
        },
        sortTitle: {
          type: String,
          default: '',
        },
        sortItemDate: {
          type: String,
          default: '',
        },
        sortItemTitle: {
          type: String,
          default: '',
        },
        lang: {
          type: String,
          default: 'de',
        },
      },
  data() {
    return {
      slide: 0,
      transition: 'slide-fade-left',
      posts: null,
      perPage: 1,
      filterSlug: null,
      loading: false,
      loadingMore: false,
      mehrVisible: true,
      orderBy: 'date',
      orderChanged: false,
      newsletterEmail: '',
      newsletterInvalid: false,
      customTypesOrderd: [],
    };
  },
  mounted() {
    this.allCount = this.postsCount;
    this.posts = this.articles ? [...this.articles] : null;
    this.orderCustomTypes();
    this.addStaticData();
    this.perPage = this.posts ? this.posts.length : 1;
    this.mehrVisible = this.loaderOn;
  },

  methods: {
    resetNewsletterError() {
      this.newsletterInvalid = false;
    },

    newsletterSubmit() {

      this.newsletterEmail && this.newsletterEmail.match(/\S+@\S+\.\S+/)
          // ? window.location = this.newsletterData.formUrl + this.newsletterEmail
        ? window.open(this.newsletterData.formUrl + this.newsletterEmail, '_blank')
        : this.newsletterInvalid = true;
    },

    orderCustomTypes() {
      if (!this.staticItems) return;
      this.customTypesOrderd = [...this.staticItems].sort((a, b) => a.index - b.index);
    },
    addStaticData() {
      if (!this.filterSlug && this.posts && this.staticItems) {
        const newPosts = [...this.posts];
        // item.index is the final grid position, so inserting in ascending order needs no offset
        this.customTypesOrderd.forEach((item) => {
          newPosts.splice(Math.min(item.index, newPosts.length), 0, { ...item, customType: item.type });
        });
        this.posts = newPosts;
      }
    },

    filterChange(filterSlug) {
      // console.log('filterSlug', filterSlug);
      this.loading = true;
      this.filterSlug = filterSlug;
      this.loadMore('filter');
    },

    orderChange() {
      // console.log('orderBy', this.orderBy);
      this.loading = true;
      this.loadMore('orderby');
      this.orderChanged = true;
    },

    loadMore(filterOnly = '') {
      // console.log('load more now / filterOnly', filterOnly);

      // show loading more spinner only for loadMore actions
      // and not for filter actions
      if (!filterOnly) {
        this.loadingMore = true;
      }
      let postsBefore = this.posts.length;
      let numberOfPosts = 0;
      if (filterOnly === 'filter') {
        // console.log('filter', postsBefore);
        // first filter click - reset posts
        numberOfPosts = this.perPage;
        postsBefore = 0;
        this.mehrVisible = true;
      } else if (filterOnly === 'orderby') {
        // console.log('orderby', postsBefore);
        numberOfPosts = this.posts.length;
      } else {
        numberOfPosts = this.posts.length + this.perPage;

      }

      this.allCount = numberOfPosts;

      if (!this.filterSlug && this.staticItems) {
        this.staticItems.forEach((item) => {
          if (numberOfPosts > item.index) {
            numberOfPosts--;
          }
        });
      }

      // one extra post, as the excluded one is filtered out of the response
      let queryString = `perPage=${numberOfPosts + (this.excludePermalink ? 1 : 0)}`;
      let order = 'DESC';

      switch (this.orderBy) {
      case 'date':
        order = 'DESC';
        break;
      case 'author':
        order = 'ASC';
        break;
      case 'title':
        order = 'ASC';
        break;
      case 'comment_count':
        order = 'DESC';
        break;
      default:
        order = 'DESC';
      }

      if (this.orderBy) {
        queryString += `&orderBy=${this.orderBy}&order=${order}`;
      }

      console.log('post type: ' + this.postType);
      if (this.postType) {
        queryString += `&postType=${this.postType}`;
      }

      if (this.lang) {
        queryString += `&lang=${this.lang}`;
      }

      if (this.filterSlug) {
        queryString += `&categoryFilter=${this.filterSlug}`;
      }

      if (this.archiveFilters && this.archiveFilters.tagFilter) {
        queryString += `&tagFilter=${this.archiveFilters.tagFilter}`;
      }

      if (this.archiveFilters && this.archiveFilters.categoryFilter && !this.filterSlug) {
        queryString += `&categoryFilter=${this.archiveFilters.categoryFilter}`;
      }

      if (this.archiveFilters && this.archiveFilters.authorFilter) {
        queryString += `&authorFilter=${this.archiveFilters.authorFilter}`;
      }

      if (this.archiveFilters && this.archiveFilters.archived) {
        queryString += `&archived=${this.archiveFilters.archived}`;
      }

      if (this.archiveFilters && this.archiveFilters.yearFilter) {
        // console.log('year filter here');
        queryString += `&yearFilter=${this.archiveFilters.yearFilter}`;

        if (this.archiveFilters.monthFilter) {
          queryString += `&monthFilter=${this.archiveFilters.monthFilter}`;

          if (this.archiveFilters.dayFilter) {
            queryString += `&dayFilter=${this.archiveFilters.dayFilter}`;
          }
        }
      }

      // console.log('queryString', queryString);


      fetch(`${this.apiUrl}bwpspace/v1/latest_posts_for_thumbs?${queryString}`)
        .then((response) => response.json())
        .then((data) => {

          this.posts = this.excludePermalink
            ? data.filter((post) => post.permalink !== this.excludePermalink).slice(0, numberOfPosts)
            : data;
          this.loading = false;
          this.loadingMore = false;

            // hide mehrVisible if no new or not enough posts loaded
          //console.log(this.posts.length, postsBefore, this.perPage, this.posts.length === postsBefore, this.posts.length < this.perPage);
          //console.log('mehr', this.posts.length === postsBefore, this.posts.length < this.perPage);
          if ((this.posts.length === postsBefore && !this.orderChanged)
                || this.posts.length < this.perPage
                || this.posts.length < numberOfPosts
          ) {
            this.mehrVisible = false;
          }

          this.addStaticData();

          this.orderChanged = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.loadingMore = false;
          this.orderChanged = false;
        });
    },
  },
};

</script>

<style scoped lang="scss">
</style>
